// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const graveler: PokeData = {
  "id": 75,
  "name": "graveler",
  "height": 10,
  "weight": 1050,
  "base_experience": 137,
  "types": [
    PokeType.ROCK,
    PokeType.GROUND
  ],
  "api_moves": [
    "sand-attack",
    "tackle",
    "take-down",
    "double-edge",
    "rock-throw",
    "earthquake",
    "harden",
    "defense-curl",
    "bide",
    "self-destruct",
    "explosion",
    "rock-slide",
    "mud-slap",
    "sandstorm",
    "rollout",
    "magnitude",
    "mud-sport",
    "iron-defense",
    "rock-blast",
    "rock-polish",
    "stone-edge",
    "stealth-rock",
    "smack-down",
    "bulldoze"
  ],
  "moves": [
    "tackle",
    "rock-throw",
    "earthquake",
    "rock-slide",
    "mud-slap",
    "sandstorm",
    "magnitude",
    "rock-blast",
    "stealth-rock",
    "stone-axe",
    "rototiller",
    "mud-shot",
    "seismic-toss"
  ],
  "evolution_chain": {
    "id": 31,
    "item": null,
    "species": [
      {
        "name": "geodude",
        "order": 80,
        "types": [
          PokeType.ROCK,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "graveler",
        "order": 81,
        "types": [
          PokeType.ROCK,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 74,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "golem",
        "order": 82,
        "types": [
          PokeType.ROCK,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 75,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 67.5,
    "speed": 35,
    "ability_power": 95
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
